import React from 'react';
import { motion } from 'framer-motion';
import './RACWhatYouGet.css';

const RACWhatYouGet = () => {
  console.log('[RACWhatYouGet] Component rendered');
  
  const benefits = [
    {
      icon: '📜',
      title: 'Ownership Certificate + Animal ID (RFID/tag) record'
    },
    {
      icon: '📋',
      title: 'Executed Hire-back Agreement + Payment Schedule (Hire Rent)'
    },
    {
      icon: '🛡️',
      title: 'Insurance policy document (policyholder: owner; beneficiary: PharmWealth; policy terms/exclusions apply)'
    },
    {
      icon: '🏥',
      title: 'Onboarding health record and vet notes (as applicable)'
    },
    {
      icon: '📊',
      title: 'Daily logs/records and monthly hire rent statements'
    },
    {
      icon: '🏭',
      title: 'Farm visit option by appointment'
    }
  ];
  
  return (
    <section className="rac-what-you-get">
      <div className="rac-what-you-get-container">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="rac-section-title"
        >
          What You Get
        </motion.h2>
        <div className="rac-gold-line"></div>
        
        <div className="rac-benefits-grid">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="rac-benefit-card"
            >
              <div className="rac-benefit-icon">{benefit.icon}</div>
              <h3 className="rac-benefit-title">{benefit.title}</h3>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RACWhatYouGet;


